import React, { useMemo, useEffect, useState, useCallback } from 'react';
import { InputSelect } from '~/components/NovosInputs';
import { SubModulo, Select } from '../../../protocols';
import api from '~/services/api';
import { useTela } from '../../../TelaContext';
import { errorHandler } from '~/utils/ErrorHandler';

export const SubModuloContainer: React.FC<{ cod_modulo: number }> = ({
  cod_modulo,
}) => {
  const [subModulos, setSubModulos] = useState<Select[]>([]);
  const { formTela } = useTela();

  const {
    register,
    formState: { errors },
    control,
    setValue,
    clearErrors,
  } = formTela;

  const getSubModulos = useCallback(async () => {
    try {
      const res = await api.get(`/modulo/sub-modulo/${cod_modulo}`);
      const { data, success, message } = res.data;
      if (!success) throw new Error(message);

      const regs = data.map((item: SubModulo) => {
        return {
          value: item.cod_seq_modulo_secao,
          label: `${item.des_modulo_secao}`,
        };
      });

      setSubModulos(regs);
    } catch (e: any) {
      errorHandler(e);
    }
  }, [cod_modulo]);

  // Ordenar os Sub módulos em ordem alfabética
  const sortedSubModulos = useMemo(
    () =>
      subModulos
        .slice()
        .sort((a, b) =>
          a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }),
        ),
    [subModulos],
  );

  useEffect(() => {
    if (!cod_modulo) {
      return setValue('cod_modulo_secao', null);
    }
    getSubModulos();
  }, [cod_modulo, getSubModulos, setValue]);

  return (
    <>
      <InputSelect
        label="SubMódulo"
        placeholder="- Selecione o submódulo -"
        name="cod_modulo_secao"
        register={register}
        isError={!!errors.cod_modulo_secao}
        control={control}
        options={sortedSubModulos}
        disabled={!cod_modulo}
        changeSelected={(selected) => {
          clearErrors('cod_modulo_secao');
          setValue('cod_modulo_secao', selected);
        }}
      />
    </>
  );
};
